module.exports = __webpack_public_path__ + "img/icon_zuixing_hover@2x.5fa9d0b1.png";